import axios from 'axios'
import React, { useEffect, useMemo, useState } from 'react'
import { authenticationService } from 'services/authentication.service';
//URL
import configData from "../../../config.json";
//TABLA
import DataTable, { TableColumn } from 'react-data-table-component';
//BOOTSTRAP
//Reactstrap
import { Card, CardTitle, CardBody, CardFooter, Container, Row, Col, Table, Input, Alert } from "reactstrap";
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import Cargando from 'components/Varios/Cargando';

import "./CronogramaVacaciones.scss"
import ModalDetalleCronogramaUnidad, { DatosLocalidadDetalle } from './ModalDetalleCronogramaUnidad';
import { alertService } from 'components/Varios/alert_service';
import ModalFirmarReporteAnual, { DatosModalFirmarReporteAnual } from './ModalFirmarReporteAnual';


type ContenidoCronograma = {
    nombrelocalidad: string,
    cantidadpersonasmes: number[],
    cantidadPlanifica: number,
    cantidadPlanificada: number,
    planificacionesCompletas: boolean,
    personasNoEnviadasTH?: number[]
}

type ContenidoCronogramaTable = {
    idlocalidadunidad: number,
    nombrelocalidad: string,
    cantidadpersonasmes: number[],
    cantidadPlanifica: number,
    cantidadPlanificada: number,
    planificacionesCompletas: boolean,
    personasNoEnviadasTH: number

}
type DictionaryCronogramaUnidades = {
    key: number,
    value: ContenidoCronograma
}
type RespuestaCronogramaUnidades = {
    cronograma_unidades: Array<DictionaryCronogramaUnidades>,
    referencia_ultimo_reporte: string,
    planificacioncompleta: boolean,
    isdirectorth: boolean
}
const CronogramaVacaciones = () => {

    const TITULO_CRONOGRAMA_VACACIONES = "Plan de Vacaciones por Unidad"

    const [componenteErrorRespuesta, setcomponenteErrorRespuesta] = useState<JSX.Element>()
    const [cronogramaUnidades, setCronogramaUnidades] = useState<Array<DictionaryCronogramaUnidades>>([])
    const [loading, setloading] = useState<boolean>(false)
    const [tablaCronogramaUnidades, settablaCronogramaUnidades] = useState<JSX.Element>()
    const [filterText, setfilterText] = useState<string>("")
    const [loadingButton, setloadingButton] = useState<boolean>(false);
    const [loadingButtonLocalidad, setloadingButtonLocalidad] = useState<boolean>(false);
    const [loadingButtonDescargar, setloadingButtonDescargar] = useState<boolean>(false);
    const [loadingButtonDescargarPDF, setloadingButtonDescargarPDF] = useState<boolean>(false);

    //Verificar si todas las planificaciones han sido enviadas
    const [planificacionesCompletas, setplanificacionesCompletas] = useState<boolean>(false);
    //Verificar si es director talento humano
    const [isDirectorTH, setisDirectorTH] = useState<boolean>(false)


    //Mostrar modal segun idlocalidad
    const [datosLocalidadModal, setdatosLocalidadModal] = useState<DatosLocalidadDetalle>({ idlocalidadunidad: -2, nombrelocalidadunidad: "" })
    // const [datosLocalidadModal, setdatosLocalidadModal] = useState<DatosLocalidadDetalle>({ idlocalidadunidad: 18, nombrelocalidadunidad: "TH" })


    const [idlocalidadModal, setidlocalidadModal] = useState<number>(-2);
    const [showModalLocalidad, setshowModalLocalidad] = useState<boolean>(false);
    //
    const [referenciaReporteAnual, setreferenciaReporteAnual] = useState<string>("");

    //Mostrar modal para firmar
    const [showModalFirmarReporte, setshowModalFirmarReporte] = useState<boolean>(false)
    const [datosModalFirmarReporte, setdatosModalFirmarReporte] = useState<DatosModalFirmarReporteAnual>({
        urlPDF: "",
        archivoPDF: null
    })


    // SOBRE REPORTES

    const descargarCronograma = async () => {
        setloadingButton(true);
        var currentUser = authenticationService.currentUserValue;

        await fetch(configData.SERVER_URL + "PlanificacionVacaciones/Administrador/Reporte", {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`,

            },
        })
            .then(response => {
                response.blob()
                    .then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        var file_object = new File([blob], "reporte_planificacion_anual");
                        setdatosModalFirmarReporte({
                            urlPDF: url,
                            archivoPDF: file_object
                        })
                        // let a = document.createElement('a');
                        // a.href = url;
                        // a.download = "reporte_planificacion_anual"  //nombrearchivo
                        // a.click();
                    });
            })
            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });
        setloadingButton(false);
    }

    const descargarUnidadesSinPlanificar = async () => {
        setloadingButtonLocalidad(true);
        var currentUser = authenticationService.currentUserValue;

        await fetch(configData.SERVER_URL + "PlanificacionVacaciones/Administrador/Reporte/UnidadesSinPlanificar", {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`
            },
        })
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "reporte_unidades_sin_planificar"  //nombrearchivo
                    a.click();
                });
            })
            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }

                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });
        setloadingButtonLocalidad(false);
    }


    const descargarReporteFirmado = async () => {
        setloadingButtonDescargar(true);
        var currentUser = authenticationService.currentUserValue;

        await fetch(configData.SERVER_URL + "PlanificacionVacaciones/Administrador/DescargarReporteAnual", {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`
            },
        })
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "reporte_planificaciones"  //nombrearchivo
                    a.click();
                });
            })
            .catch(async (error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                var mensaje_error = "Error inesperado"
                switch (status_code) {
                    case 500:
                        mensaje_error = "Error inesperado. Intente más tarde"
                        break;
                    case 0:
                        mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                    case 401:
                        mensaje_error = "No está autorizado a realizar esta acción";
                    case 409:
                        mensaje_error = await new Blob([error_any.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
                    default:
                        break;
                }
                alertService.error(mensaje_error);
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });
        setloadingButtonDescargar(false);
    }

    const descargarPDFCronograma = async () => {
        setloadingButtonDescargarPDF(true);
        var currentUser = authenticationService.currentUserValue;

        await fetch(configData.SERVER_URL + "PlanificacionVacaciones/Administrador/Reporte/CronogramaPlanVacaciones", {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`
            },
        })
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "cronograma_vacaciones"  //nombrearchivo
                    a.click();
                });
            })
            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }

                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });
        setloadingButtonDescargarPDF(false);
    }

    const ComponentBuscadorTabla = (): JSX.Element => {
        return (
            <React.Fragment>
                <Row className="row-justify-content">
                    <Col xl={6}>
                        <input value={filterText} onChange={(e) => setfilterText(e.target.value)} placeholder="Buscar Unidad"></input>

                    </Col>
                </Row>
            </React.Fragment>

        );
    }

    useEffect(() => {
        if (tablaCronogramaUnidades !== undefined && filterText !== "") {
            var filtrado: Array<DictionaryCronogramaUnidades> = cronogramaUnidades;

            if (filterText != "") {
                filtrado = filtrado.filter(item => {
                    return item.value.nombrelocalidad && item.value.nombrelocalidad.toLowerCase().includes(filterText.toLowerCase())
                })
            }

            settablaCronogramaUnidades(generar_tablaCronogramaUnidades(filtrado))

        }
        else if (filterText === "" && tablaCronogramaUnidades) {
            var filtrado: Array<DictionaryCronogramaUnidades> = cronogramaUnidades;


            settablaCronogramaUnidades(generar_tablaCronogramaUnidades(filtrado))
        }

    }, [filterText]);

    const generar_tablaCronogramaUnidades = (arrayCronogramaDirectivo: Array<DictionaryCronogramaUnidades>) => {



        const rows_tabla_calendario: Array<ContenidoCronogramaTable> = []




        arrayCronogramaDirectivo.map((diccionario) => {
            rows_tabla_calendario.push({
                cantidadpersonasmes: diccionario.value.cantidadpersonasmes,
                idlocalidadunidad: diccionario.key,
                nombrelocalidad: diccionario.value.nombrelocalidad,
                cantidadPlanifica: diccionario.value.cantidadPlanifica,
                cantidadPlanificada: diccionario.value.cantidadPlanificada,
                planificacionesCompletas: diccionario.value.planificacionesCompletas,
                personasNoEnviadasTH: diccionario.value.personasNoEnviadasTH ? diccionario.value.personasNoEnviadasTH.length : 0


            })
        });


        const handleClickNombreLocalidad = (nombre: string, id: number) => {
            setdatosLocalidadModal({ idlocalidadunidad: id, nombrelocalidadunidad: nombre });
        }


        const columns: TableColumn<ContenidoCronogramaTable>[] = [
            {
                name: "Unidad",
                selector: (row) => row.nombrelocalidad,
                cell: (row) => {
                    return (

                        <div
                            onClick={() => {
                                if (row.idlocalidadunidad === -1) {
                                    setidlocalidadModal(-2)
                                }
                                else {
                                    handleClickNombreLocalidad(row.nombrelocalidad, row.idlocalidadunidad)
                                    // if (row.cantidadpersonasmes){
                                    //     var total:number = 0;
                                    //     row.cantidadpersonasmes.map((numeros,indice) => {
                                    //         total+=numeros
                                    //     })
                                    //     if(total > 0){
                                    //         handleClickNombreLocalidad(row.nombrelocalidad, row.idlocalidadunidad)
                                    //     }
                                    // }
                                }

                            }
                            }
                            className="nombre_unidad"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={row.nombrelocalidad}
                            data-bs-custom-class="toogle_personalizado_aprobar">
                            {row.nombrelocalidad === "ZTOTAL" ? "" : row.nombrelocalidad}
                        </div>)
                },
                sortable: true,
                // conditionalCellStyles: [
                //     {
                //         when: row => {
                //             if (row.cantidadpersonasmes){
                //                 var total:number = 0;
                //                 row.cantidadpersonasmes.map((numeros,indice) => {
                //                     total+=numeros
                //                 })
                //                return total <= 0
                //             }
                //             return true
                //         },
                //         style: {                            
                //             color: '#243165',
                //             overflow: "visible",
                //             wordBreak: "break-word",
                //             opacity:'1',
                //             cursor: 'default'
                //         },
                //     }
                // ],
                style: {
                    color: '#243165',
                    overflow: "visible",
                    wordBreak: "break-word",
                    '&:hover': {
                        cursor: 'pointer',
                        opacity: '0.5',
                    }
                },
                center: true,
                minWidth: "100px",
                width: "120px",
                maxWidth: "150px"

            },
            // {
            //     name: "Planificada",
            //     selector: (row) => {
            //         if(row.idlocalidadunidad === -1 ){
            //             return "NO"
            //         }
            //         else {
            //             return row.planificacionesCompletas?"SI":"NO"
            //         }
            //     },
            //     sortable: true,
            //     center: true,
            //     minWidth: "100px",
            //     width: "120px",
            //     maxWidth: "150px"

            // },
            {
                name: "Personal Planificado pero no Enviado a TH",
                selector: (row) => row.personasNoEnviadasTH,
                sortable: true,
                center: true,
                minWidth: "100px",
                width: "150px",
                maxWidth: "150px"

            },
            {
                name: "Enero",
                selector: (row) => row.cantidadpersonasmes[0],
                sortable: true,
                center: true,
                width: "100px"

            },
            {
                name: "Febrero",
                selector: (row) => row.cantidadpersonasmes[1],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Marzo",
                selector: (row) => row.cantidadpersonasmes[2],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Abril",
                selector: (row) => row.cantidadpersonasmes[3],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Mayo",
                selector: (row) => row.cantidadpersonasmes[4],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Junio",
                selector: (row) => row.cantidadpersonasmes[5],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Julio",
                selector: (row) => row.cantidadpersonasmes[6],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Agosto",
                selector: (row) => row.cantidadpersonasmes[7],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Septiembre",
                selector: (row) => row.cantidadpersonasmes[8],
                sortable: true,
                center: true,
                width: "100px"


            },
            {
                name: "Octubre",
                selector: (row) => row.cantidadpersonasmes[9],
                sortable: true,
                center: true,
                width: "100px"


            }, {
                name: "Noviembre",
                selector: (row) => row.cantidadpersonasmes[10],
                sortable: true,
                center: true,
                width: "100px"


            }, {
                name: "Diciembre",
                selector: (row) => row.cantidadpersonasmes[11],
                sortable: true,
                center: true,
                width: "100px"


            }
        ]


        const customStyles_tabla = {
            table: {
                style: {
                    // "max-width": "max-content"
                },
            },
            tableWrapper: {
                style: {
                    display: 'table',
                    // border:"solid 1px",
                    // "border-color":"gray"
                },
            },


            headRow: {
                style: {
                    backgroundColor: "#243165",
                    color: "white",
                    fontSize: '1.1em',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    wordBreak: "break-word ",


                },

            },
            headCells: {
                style: {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    wordBreak: "break-word ",

                },

            },
            cells: {
                style: {
                    paddingLeft: '0px',
                    paddingRight: '0px',

                    // wordBreak: 'break-word',
                    "overflow": "visible",
                    "white-space": "nowrap",
                    wordBreak: "break-word ",
                },
            },
            rows: {
                style: {
                    // maxHeight: '40px',
                    // maxWidth:'20px', 
                    fontSize: '1.1em',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    wordBreak: "break-word ",


                },
            },

        }
        const conditionalRowStyles = [
            {
                when: row => row.nombrelocalidad === "ZTOTAL",
                style: {
                    "fontWeight": "bold",
                }
            }
        ];
        const paginationComponentOptions = {
            rowsPerPageText: 'Filas por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todos',
        };
        const paginationrows = [5, 10, 15, 20, 25]


        return (
            <DataTable
                columns={columns}
                data={rows_tabla_calendario}
                striped
                responsive={true}
                customStyles={customStyles_tabla}
                pagination paginationComponentOptions={paginationComponentOptions}
                paginationRowsPerPageOptions={paginationrows}
                subHeaderComponent={ComponentBuscadorTabla()}
                subHeader={true}
                conditionalRowStyles={conditionalRowStyles}
            />

        )

    }

    const handleCloseModalDetalle = () => {
        setidlocalidadModal(-2);
        setdatosLocalidadModal(
            {
                idlocalidadunidad: -2,
                nombrelocalidadunidad: ""
            }
        )
    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";

        //const Obtener_informacion_cronograma = async () => {
        //    setloading(true);

        //    var currentUser = authenticationService.currentUserValue;
        //    try {
        //        const respuesta_cronograma = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/Administrador/CronogramaUnidades`,
        //            {
        //                headers: {
        //                    Authorization: `KEYESPOL ${currentUser?.token}`
        //                }
        //            });
        //        const informacion_Cronograma: RespuestaCronogramaUnidades = respuesta_cronograma.data;
        //        setCronogramaUnidades(informacion_Cronograma.cronograma_unidades);
        //        setreferenciaReporteAnual(informacion_Cronograma.referencia_ultimo_reporte);
        //        setplanificacionesCompletas(informacion_Cronograma.planificacioncompleta);
        //        setisDirectorTH(informacion_Cronograma.isdirectorth);
        //        // setreferenciaReporteAnual("asas");
        //        // setplanificacionesCompletas(true);
        //        var tablita = generar_tablaCronogramaUnidades(informacion_Cronograma.cronograma_unidades)
        //        settablaCronogramaUnidades(tablita)

        //    } catch (error) {
        //        var error_any: any = error;
        //        var status: number = handle_error(error_any);
        //        var mensaje = "Ha ocurrido un inconveniente"
        //        if(axios.isAxiosError(error) && error.response){
        //            mensaje = error.response.data;
        //        }
        //        switch (status) {
        //            case 401:
        //                setcomponenteErrorRespuesta(
        //                    <React.Fragment>
        //                        <div>No está autorizado a realizar está acción</div>
        //                    </React.Fragment>
        //                )
        //                break;
        //            case 500:
        //                setcomponenteErrorRespuesta(
        //                    <React.Fragment>
        //                        <div>Ha ocurrrido un error inesperado, intente más tarde</div>
        //                    </React.Fragment>
        //                )
        //            case -1:
        //                setcomponenteErrorRespuesta(
        //                    <React.Fragment>
        //                        <div>No ha sido posible contactar con el servidor.</div>
        //                    </React.Fragment>
        //                )
        //            default:
        //                setcomponenteErrorRespuesta(
        //                    <React.Fragment>
        //                        <div>{mensaje}</div>
        //                    </React.Fragment>
        //                )
        //                break;
        //        }
        //    }
        //    setloading(false);

        //}

        //Obtener_informacion_cronograma();


    }, [])

    useEffect(() => {
        if (idlocalidadModal !== -2) {
            setshowModalLocalidad(true);
        }
    }, [idlocalidadModal])

    useEffect(() => {
        setidlocalidadModal(datosLocalidadModal.idlocalidadunidad);
    }, [datosLocalidadModal.idlocalidadunidad, datosLocalidadModal.nombrelocalidadunidad])


    useEffect(() => {
        const { urlPDF, archivoPDF } = datosModalFirmarReporte
        if (urlPDF !== "" && archivoPDF !== null) {
            setshowModalFirmarReporte(true);
        }
    }, [datosModalFirmarReporte.urlPDF, datosModalFirmarReporte.archivoPDF])



    // if (loading) { 
    //     return (
    //         <div className="content">
    //             <Cargando mensaje='Cargando Reporte Planificaciones Unidades' /> 
    //         </div>
    //     )


    // }



    return (
        <div className="content">
            <Container fluid={true}>
                <Row>
                    <Col xl={12}>
                        <h4> {TITULO_CRONOGRAMA_VACACIONES} </h4>
                        <div>{loading ? "Verificando las planificaciones..." : planificacionesCompletas ? "Todas las planificaciones han sido enviadas a Talento Humano" : "Aún faltan planificaciones por  enviar a Talento Humano"}</div>
                    </Col>
                </Row>
                <Row className="justify-content-end mb-2 ">
                    {planificacionesCompletas && isDirectorTH &&
                        <Col xl={2} md={5} sm={12} className="text-center text-md-0">
                            {
                                !loadingButtonDescargarPDF &&
                                <button disabled={loadingButton} className="btnDescargarCronogramaPlanVac" onClick={() => descargarPDFCronograma()}>Descargar Cronograma de Plan de Vacaciones</button>
                            }
                            {
                                loadingButtonDescargarPDF &&
                                <button className="btnDescargarCronogramaPlanVac">Descargando Reporte...</button>
                            }
                        </Col>
                    }

                    <Col xl={2} md={5} sm={12} className="mb-2 mb-sm-2 mb-md-0 text-center text-md-0">
                        {
                            !loadingButtonLocalidad &&
                            <button disabled={loadingButtonLocalidad} className="btnDescargarCronogramaPlanVac" onClick={() => descargarUnidadesSinPlanificar()}>Exportar listado de Unidades sin Planificar</button>
                        }
                        {
                            loadingButtonLocalidad &&
                            <button className="btnDescargarCronogramaPlanVac">Preparando Reporte...</button>
                        }
                    </Col>
                    
                    {referenciaReporteAnual === "" && planificacionesCompletas && isDirectorTH &&

                        <Col xl={2} md={5} sm={12} className="text-center text-md-0">
                            {
                                !loadingButton &&
                                <button disabled={loadingButton} className="btnDescargarCronogramaPlanVac" onClick={() => descargarCronograma()}>Firmar Reporte Anual Planificación Vacaciones</button>
                            }
                            {
                                loadingButton &&
                                <button className="btnDescargarCronogramaPlanVac">Preparando Reporte...</button>
                            }
                        </Col>
                    }
                    {referenciaReporteAnual !== "" && planificacionesCompletas && isDirectorTH &&

                        <Col xl={2} md={5} sm={12} className="text-center text-md-0">
                            {
                                !loadingButtonDescargar &&
                                <button disabled={loadingButton} className="btnDescargarCronogramaPlanVac" onClick={() => descargarReporteFirmado()}>Descargar Reporte Anual Firmado</button>
                            }
                            {
                                loadingButtonDescargar &&
                                <button className="btnDescargarCronogramaPlanVac">Descargando Reporte...</button>
                            }
                        </Col>
                    }


                </Row>
                <Row className="justify-content-center">
                    <Col xl={12} className="col-table-cronograma" >
                        {componenteErrorRespuesta}
                        {loading &&
                            <div className="content">
                                <Cargando mensaje='Cargando Reporte Planificaciones Unidades' />
                            </div>
                        }

                        {!loading && tablaCronogramaUnidades}
                    </Col>

                </Row>
                <ModalDetalleCronogramaUnidad
                    show={showModalLocalidad}
                    onClose={() => handleCloseModalDetalle()}
                    toogle={() => setshowModalLocalidad(!showModalLocalidad)}
                    datosLocalidad={datosLocalidadModal}
                />
                <ModalFirmarReporteAnual
                    show={showModalFirmarReporte}
                    onClose={() => setshowModalFirmarReporte(false)}
                    toogle={() => setshowModalFirmarReporte(!showModalFirmarReporte)}
                    datosModal={datosModalFirmarReporte}
                />
            </Container>

        </div>
    )
}
export default CronogramaVacaciones;
